import styled from "styled-components";

import { textFieldStyles, withInputSizeStyles } from "../../../styled";

export const Container = styled.div``;

export const Input = styled.input.attrs(({ isValid, isVisible }) => ({
  type: isVisible ? "text" : "password",
  "aria-invalid": !isValid
}))`
  ${textFieldStyles};
  ${withInputSizeStyles};
  box-sizing: border-box;
`;

export const ShowPasswordButton = styled.button`
  background: none;
  border: 0;
  margin-left: -36px;
  padding: 10px 0;
  vertical-align: middle;
  width: 30px;
`;
